import { render, staticRenderFns } from "./TherapistCallBanner.vue?vue&type=template&id=77904852&scoped=true"
import script from "./TherapistCallBanner.vue?vue&type=script&lang=js"
export * from "./TherapistCallBanner.vue?vue&type=script&lang=js"
import style0 from "./TherapistCallBanner.vue?vue&type=style&index=0&id=77904852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77904852",
  null
  
)

export default component.exports